<template>
  <div ref="swiper_banner" class="swiper-banner swiper" :class="setLayoutColor">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <div class="banner__image">
          <img src="@/assets/images/banner-22.png" />
        </div>
      </div>
      <div class="swiper-slide">
        <div class="banner__image">
          <img src="@/assets/images/banner-24.png" />
        </div>
      </div>
    </div>
    <div class="banner__navigation">
      <div class="swiper-pagination banner__pagination"></div>
      <div class="swiper-button-prev banner__button banner__button-prev"></div>
      <div class="swiper-button-next banner__button banner__button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css/bundle";

export default {
  name: "SwiperBanner",
  mounted() {
    new Swiper(this.$refs.swiper_banner, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      speed: 2000,
    });
  },
  computed: {
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `swiper-banner_${this.layoutColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-banner {
  width: 100%;
  height: 100%;

  :global(.swiper-pagination-bullet) {
    // background-color: $color-white;
    width: 10px;
    height: 10px;
    border-radius: 0.5rem;
    // opacity: 1;
  }

  :global(.swiper-pagination-bullet-active) {
    background-color: $color-yellow;
  }

  &_purple {
    & .banner__button {
      color: $color-yellow;
    }
  }

  &_red {
    & .banner__button {
      color: $color-dark-yellow;
    }
  }
}

.banner {
  &__image {
    width: 100%;
    height: 100%;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__navigation {
    width: 218px;
    height: 60px;
    position: absolute;
    bottom: 0%;
    right: 6%;
  }

  &__pagination {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__button {
    &-next {
      right: 30px;
    }

    &-prev {
      left: 30px;
    }
  }
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 30px;
}

@media screen and (max-width: 980px) {
  .swiper-banner {
    height: 80%;
  }

  .banner {
    &__navigation {
      bottom: 12%;
    }

    &__image {
      height: 78%;

      & img {
        object-fit: contain;
      }
    }
  }
}

@media screen and (max-width: 690px) {
  .swiper-banner {
    height: 92%;
  }
}

@media screen and (max-width: 468px) {
  .banner {
    &__navigation {
      bottom: 0%;
    }
  }
}
</style>
